import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const DropZoneArea = styled.div`
	display: flex;
	background-color: white;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 32px;
	border: 2px dashed ${colors.green1};
	border-radius: 1px;
	height: 100%;
	width: 100%;
`;

export const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: white;
	border: 2px dashed ${colors.amber};
	border-radius: 1px;
	height: 100%;
	width: 100%;
	padding: 16px 0;
`;

export const DropZoneText = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
`;

export const DropWrapper = styled.div`
	outline: none;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const DescriptionText = styled.div`
	color: ${colors.grey5};
	font-size: 16px;
	text-align: center;

	span {
		color: ${colors.grey8};
	}
`;

export const Text = styled.div`
	color: ${colors.grey8};
	font-size: 16px;
	text-align: center;
	letter-spacing: 0.3px;
	white-space: nowrap;
	${({ bold }) => bold && 'font-weight: 500;'};
`;

export const TextTruncate = styled(Text)`
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const StatusText = styled.div`
	font-size: 19px;
	text-align: center;
	color: ${colors.grey6};
`;

export const ButtonWrapper = styled.div`
	padding-top: 20px;
`;

export const IconWrapper = styled.div`
	height: 64px;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
`;

export const TextWrapper = styled.div`
	display: flex;
	padding: 0 32px;
	width: 100%;
	justify-content: center;
`;
